import { AvatarClient } from "@/components";
import { IClient } from "@/types";

const RecentClients = ({
  clients,
  onSelectClient,
}: {
  clients: IClient[];
  onSelectClient: (client: IClient) => void;
}) => {
  return (
    <>
      <div className="flex items-center justify-between">
        <div>Recent clients</div>
      </div>
      <div>
        {clients.map((recent: IClient, i: number) => {
          return (
            <AvatarClient
              key={"av-" + i}
              disableCancel
              onClick={() => onSelectClient(recent)}
              {...recent}
            />
          );
        })}
      </div>
    </>
  );
};

export default RecentClients;
